interface TableTDListListProps {
    items: (string | JSX.Element)[];
}

const TableTDListList: React.FC<TableTDListListProps> = ({ items = [] }) => {
    return (
        <ul style={{
            listStyleType: "none",
            padding: '0 0 0 5px',
            margin: 0,
        }}>
            {items?.map((item:string | JSX.Element, index:number) => (
                <li key={index} style={{
                    padding: '0 0 4px 4px',
                }}>
                    {item}
                </li>
            ))}
        </ul>
    );
};

export default TableTDListList;